import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import * as React from "react";
import { getActivityRowId } from "../../utils/activityUtils";
import { RECENT_ACTIVITY_PAGE_SIZE } from "../../utils/activityConstants";

interface RecentActivityProps {
  recentActivity: any[];
}

export const RecentActivity: React.FC<RecentActivityProps> = ({
  recentActivity,
}) => {
  const recentActivityColumns: GridColDef[] = [
    {
      field: "user",
      headerName: "User",
      width: 300,
      editable: false,
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ display: "flex", flexDirection: "column", py: 0.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.2 }}>
            {params.row.user_name}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ lineHeight: 1.2 }}
          >
            {params.row.user_email}
          </Typography>
        </Box>
      ),
    },
    {
      field: "fbo_name",
      headerName: "FBO",
      width: 250,
      editable: false,
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      width: 250,
      editable: false,
      valueGetter: (_, row) => new Date(row.timestamp).toLocaleString(),
    },
  ];

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ width: "100%", minWidth: 700, p: 1 }}
    >
      {recentActivity.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography color="text.secondary">No recent activity</Typography>
        </Box>
      ) : (
        <Box
          sx={{
            height: "calc(100vh - 300px)", // Full height minus headers
            width: "100%",
            overflow: "auto",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            "&::-webkit-scrollbar": {
              width: "14px",
              height: "14px",
              display: "block !important",
            },
            "&::-webkit-scrollbar-track": {
              background: (theme) => theme.palette.action.hover,
              borderRadius: "7px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: (theme) => theme.palette.text.secondary,
              borderRadius: "7px",
              border: (theme) => `2px solid ${theme.palette.action.hover}`,
              "&:hover": {
                background: (theme) => theme.palette.text.primary,
              },
            },
            "&::-webkit-scrollbar-corner": {
              background: (theme) => theme.palette.action.hover,
            },
          }}
        >
          <Box sx={{ minWidth: "fit-content" }}>
            <DataGrid
              autoHeight
              rows={recentActivity.map((activity, idx) => ({
                ...activity,
                id: getActivityRowId(activity, idx),
              }))}
              columns={recentActivityColumns}
              pageSizeOptions={[RECENT_ACTIVITY_PAGE_SIZE]}
              disableRowSelectionOnClick
              disableColumnMenu
              disableColumnFilter
              disableColumnSelector
              getRowHeight={() => "auto"}
              sx={{
                "& .MuiDataGrid-cell": {
                  alignItems: "center",
                  display: "flex",
                },
                "& .MuiDataGrid-pinnedColumns": {
                  boxShadow: "2px 0 5px -2px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "background.paper",
                },
                "& .MuiDataGrid-pinnedColumns .MuiDataGrid-cell": {
                  backgroundColor: "background.paper",
                },
              }}
            />
          </Box>
        </Box>
      )}
    </Stack>
  );
};